import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

class AdminService {
  // ✅ FIXED: Get all users
  getAllUsers() {
    console.log('🔄 Fetching all users...');
    return axios.get(config.api.admin + '/users', {
      headers: authHeader()
    });
  }

  // ✅ FIXED: Freeze/unfreeze user
  toggleUserFreeze(userId) {
    console.log('🔄 Toggling user freeze:', userId);
    return axios.post(config.api.admin + '/user/freeze',
      { userId },
      { headers: authHeader() }
    );
  }

  // ✅ FIXED: Set user offline
  setUserOffline(userId) {
    console.log('🔄 Setting user offline:', userId);
    return axios.post(config.api.admin + '/user/offline',
      { userId },
      { headers: authHeader() }
    );
  }

  // ✅ FIXED: Deduct from user balance
  deductFromUser(userId, amount, reason) {
    console.log('🔄 Deducting from user:', userId, 'Amount:', amount);
    return axios.post(config.api.admin + '/user/deduct',
      { userId, amount, reason },
      { headers: authHeader() }
    );
  }

  // ✅ ADDED: Add to user balance
  addToUser(userId, amount, reason) {
    console.log('🔄 Adding to user:', userId, 'Amount:', amount);
    return axios.post(config.api.admin + '/user/add',
      { userId, amount, reason },
      { headers: authHeader() }
    );
  }

  // ✅ ADDED: Freeze user balance
  freezeBalance(userId, amount, reason) {
    console.log('🔄 Freezing balance for user:', userId, 'Amount:', amount);
    return axios.post(config.api.admin + '/user/freeze-balance',
      { userId, amount, reason },
      { headers: authHeader() }
    );
  }

  // ✅ ADDED: Unfreeze user balance
  unfreezeBalance(userId, amount, reason) {
    console.log('🔄 Unfreezing balance for user:', userId, 'Amount:', amount);
    return axios.post(config.api.admin + '/user/unfreeze-balance',
      { userId, amount, reason },
      { headers: authHeader() }
    );
  }

  // ✅ ADDED: Update credit score
  updateCreditScore(userId, creditScore, reason) {
    console.log('🔄 Updating credit score for user:', userId, 'Score:', creditScore);
    return axios.post(config.api.admin + '/user/credit-score',
      { userId, creditScore, reason },
      { headers: authHeader() }
    );
  }

  // ✅ FIXED: Send message to user
  sendMessageToUser(userId, title, message) {
    console.log('🔄 Sending message to user:', userId);
    return axios.post(config.api.admin + '/user/message',
      { userId, title, message },
      { headers: authHeader() }
    );
  }

  // ✅ FIXED: Generate invitation code
  generateInvitationCode(username, password) {
    return axios.post(config.api.admin + '/invitation/generate',
      { username, password },
      { headers: authHeader() }
    );
  }

  // ✅ FIXED: Get all invitation codes
  getAllInvitationCodes() {
    return axios.get(config.api.admin + '/invitation/codes', {
      headers: authHeader()
    });
  }

  // ✅ FIXED: Get admin dashboard stats
  getAdminDashboard() {
    console.log('🔄 Fetching admin dashboard...');
    return axios.get(config.api.admin + '/dashboard', {
      headers: authHeader()
    });
  }

  // --- RECHARGE MANAGEMENT ---
  getAllRecharges(status = 'all') {
    return axios.get(config.api.admin + `/recharges?status=${status}`, { headers: authHeader() });
  }

  approveRecharge(rechargeId, note = '') {
    return axios.post(config.api.admin + '/recharge/approve',
      { rechargeId, adminUsername: 'admin', note },
      { headers: authHeader() }
    );
  }

  rejectRecharge(rechargeId, note = '') {
    return axios.post(config.api.admin + '/recharge/reject',
      { rechargeId, adminUsername: 'admin', note },
      { headers: authHeader() }
    );
  }

  // --- WITHDRAWAL MANAGEMENT ---
  getAllWithdrawals(status = 'all') {
    return axios.get(config.api.admin + `/withdrawals?status=${status}`, { headers: authHeader() });
  }

  approveWithdrawal(withdrawalId, note = '') {
    return axios.post(config.api.admin + '/withdrawal/approve',
      { withdrawalId, adminUsername: 'admin', note },
      { headers: authHeader() }
    );
  }

  rejectWithdrawal(withdrawalId, note = '') {
    return axios.post(config.api.admin + '/withdrawal/reject',
      { withdrawalId, adminUsername: 'admin', note },
      { headers: authHeader() }
    );
  }
}

export default new AdminService();